import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { getDate } from 'utils/DateUtil'
import { DATE } from './KeyFigureConstants'
import { getLongNumber, getNumberFormat } from '../../utils/NumberUtil'
import { filter, isUndefined } from 'lodash'
import { Card, CardContent, Grid2, Tooltip } from '@mui/material'
import { getI18nOrLabel } from 'utils/StringUtil'

const SimpleKeyFigurePanel = ({
    data,
    showAllValues,
    oneStatPerLine = false,
}) => {
    const filterValue = useMemo(() => showAllValues ? data : filter(data, o => o.value && o.value !== '0'), [data, showAllValues])

    const getLabelDate = (d) => {
        if (d.typeValue) {
            if (d.typeValue === DATE) {
                return [getDate(d.value), getDate(d.value)]
            }
            return [getLongNumber(d.value), getNumberFormat(d.value)]
        }
        return [d.value, d.value]
    }

    return (
        <Card sx={{ backgroundColor: '#53a1ff' }}>
            <CardContent padding={6}>
                <Grid2 container size={12} columnSpacing={2.5} sx={{ color: 'white' }}>
                    {filterValue.map((d, idx) => {
                        const [value, tooltipValue] = getLabelDate(d)
                        const title = getI18nOrLabel(d.title)
                        const tooltip = !isUndefined(d.tooltip) ? getI18nOrLabel(d.tooltip) : ''
                        const tooltipContent = `${tooltip || title || ''} : ${tooltipValue}`
                        return (
                            <Grid2
                                key={idx}
                                container
                                size={ oneStatPerLine ? 12 :'auto'}
                                direction='column'
                                justifyContent='flex-start'
                                alignItems={ oneStatPerLine ? 'flex-start' : 'flex-end'}
                            >
                                <span style={{ fontSize: 15 }}>{title}</span>
                                <Tooltip title={tooltipContent}>
                                    <span style={{ fontSize: 25 }}>{value}</span>
                                </Tooltip>
                            </Grid2>
                        )
                    })}
                </Grid2>
            </CardContent>
        </Card>
    )
}
SimpleKeyFigurePanel.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        tooltip: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
        typeValue: PropTypes.string,
    })),
    showAllValues: PropTypes.bool,
    oneStatPerLine: PropTypes.bool,
}

export default SimpleKeyFigurePanel
